import React, { Component } from "react";
import "./styles.css";
import G from "../../../js/globals";
import E from "../../../js/events";
import A from "axios";   // Axios  - https://github.com/axios/axios
// import Divider        from "../../prefabs/divider/view";
// import Icon           from "../../prefabs/icon/view";
// import InputCheckbox  from "../../widgets/input-checkbox/view";
import InputToggle    from "../../widgets/input-toggle/view";
import InputText      from "../../widgets/input-text/view";
import SummarySection from "../../widgets/summary-section/view";
import BookingButton  from "./booking-button";

class SectionSummary extends Component {
  // ===============================================================================================
  constructor(props) {
    super(props);

    this.getBookingData           = this.getBookingData.bind(this);
    this.createBooking            = this.createBooking.bind(this);

    this.handleRequirementsChange = this.handleRequirementsChange.bind(this);
    this.handleFirstNameChange    = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange     = this.handleLastNameChange.bind(this);
    this.handleEmailChange        = this.handleEmailChange.bind(this);
    this.handlePhoneChange        = this.handlePhoneChange.bind(this);

    // this.handleCheckboxClick      = this.handleCheckboxClick.bind(this);
    this.handleToggleClick        = this.handleToggleClick.bind(this);
    this.handleToggleClick2        = this.handleToggleClick2.bind(this);
    this.handleSummaryClick       = this.handleSummaryClick.bind(this);
    this.isPhoneValid             = this.isPhoneValid.bind(this);
    this.isEmailValid             = this.isEmailValid.bind(this);
    this.isFirstNameValid         = this.isFirstNameValid.bind(this);
    this.isLastNameValid          = this.isLastNameValid.bind(this);

    this.state = {
      checked:          false,
      submittingCreate: false,
      submittingUpdate: false,
      submittingCancel: false,
    };

    this.canSubmit = false;
  }

  // ===============================================================================================
  handleRequirementsChange(value) {
    // this.setState({ special: value });
    this.props.handleAppEvent(E.events.SUMMARY_MOD_REQS, value);
  }

  // ===============================================================================================
  handleFirstNameChange(value) {
    // console.log('first name value', value)
    // this.setState({ phone: value });
    this.props.handleAppEvent(E.events.SUMMARY_MOD_FIRST_NAME, value);
  }
  handleLastNameChange(value) {
    // console.log('last name value', value)
    // this.setState({ phone: value });
    this.props.handleAppEvent(E.events.SUMMARY_MOD_LAST_NAME, value);
  }
  handleEmailChange(value) {
    // console.log('email value', value)
    // this.setState({ phone: value });
    this.props.handleAppEvent(E.events.SUMMARY_MOD_EMAIL, value);
  }
  handlePhoneChange = (value) => {
    this.props.handleAppEvent(E.events.SUMMARY_MOD_PHONE, value);
  }

  // ===============================================================================================
  handleCheckboxClick(value) {
    this.setState({ checked: value });
  }

  // ===============================================================================================
  handleToggleClick(toggle) {
    // this.setState({ checked: toggle });
    this.props.handleAppEvent(E.events.SUMMARY_TERMS_AND_COND, toggle);
  }

  // ===============================================================================================
  handleToggleClick2(toggle) {
    // this.setState({ checked: toggle });
    this.props.handleAppEvent(E.events.SUMMARY_PRIVACY_COLLECTION, toggle);
  }

  // ===============================================================================================
  handleSummaryClick(type) {
    // console.log(`SUMMARY:\n  Clicked ${type} summary`);

    let items = this.props.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === type) {
        this.props.handleSlideChangeRequest(i);
        break;
      }
    }
  }

  // ===============================================================================================
  // Collect and return object with booking data
  getBookingData(isEditMode = false) {
    if (this.props.sPackage.kids + this.props.sIntro.stars.length < this.props.sPackage.minCapacity) {
      this.props.sPackage.kids = this.props.sPackage.minCapacity - this.props.sIntro.stars.length
    }
    let newBookingData = {
      event_type:               this.props.eventType,
      user: {
        email:                 this.props.sSummary.email,
        first_name:            this.props.sSummary.first_name,
        last_name:             this.props.sSummary.last_name,
        mobile_phone:          this.props.sSummary.phone
      },
      // List of birthday children
      kids_detail:           this.props.sIntro.stars,
      // Package details
      kids_in_party:         this.props.sPackage.kids,
      adults_in_party:       (this.props.eventType === "no-host") ? 0 : this.props.sPackage.adults,
      // premium_party_package: (this.props.sPackage.isPremium) ? 1 : 0,
      premium_party_package: 0,
      auskick_package:       0,
      // Location details
      restaurants_id:        this.props.sLocation.location.id,
      // Datetime details
      party_rooms_id:        this.props.sDatetime.time.room_id,
      party_duration:        this.props.sDatetime.time.time,
      party_date:            this.props.sDatetime.date.format("YYYY-MM-DD"),
      // Cake details
      // cake:                  (this.props.sCake.isByo) ? 0 : this.props.sCake.cakes,
      cake:                  this.props.sCake.cakes,
      own_cake:              this.props.sCake.isByo,
      optional_inclusions_no_host:   this.props.sCake.optionalInclusionsNoHost,
      // Summary details
      special_requirements:  this.props.sSummary.reqs,
      // Authentication details
      // code:                  this.props.loginState.auth_session_id,
      booking_source:        "non_mmc"
    }

    if (isEditMode) {
      newBookingData.update_token = this.props.editState.update_token;
    }

    return newBookingData;
  }

  // ===============================================================================================
  // Attempt to book a party

  createBooking() {
    // console.log("SUMMARY:\n Trying to book a party! canSubmit: ", this.canSubmit);
    if (this.canSubmit !== true) { return; }

    this.setState({ submittingCreate: true });
    let newBooking = this.getBookingData();
    let newLoaderPopup = G.popups.newPopup().lock(true).type("loader");
    this.props.handleAppPopup(newLoaderPopup);

    if (newBooking.special_requirements === '' || newBooking.special_requirements === undefined) {
      newBooking.special_requirements = 'NA'
    }

    // console.log('newBooking =======', newBooking)

    // Attempt to make the booking
    // A.post(G.data.createBooking(), newBooking)
    A.post(G.data.createBooking(), newBooking, {
      headers: {
        'Authorization': `Bearer ${this.props.cake}`
      }
    })
      .then(response => {
        // console.log("SUMMARY:\n api/create", response)
        this.setState({ submittingCreate: false });
        this.props.handleAppEvent(E.events.APP_WIPE_DATA, null);

        if (this.props.eventType === "no-host") {
          window.location.href = G.pages.noHostBookingCreated();
        } else {
          window.location.href = G.pages.bookingCreated();
        }

      })

    // Error if we couldn't make the booking
    .catch((error) => {
      console.log("SUMMARY:\n api/create", error);

      let newErrorPopup = G.popups.newPopup()
        .code(G.errors.ERR_CREATE_BOOKING_FAILED)
        .heading("Something went wrong.")
        .message((
          <div>
            <p> We couldn't make your booking at this time. </p>
            <p> Please try again later. </p>
          </div>
        ))
        .confirm("Okay");

      newErrorPopup = G.popups.getAdvancedErrorPopup(newErrorPopup, error);

      if (error.response && error.response.errors) {
        switch (error.response.errors) {
          case "we have has a booking at that time please change your party time": {
            newErrorPopup.heading("That timeslot is already taken.");
            newErrorPopup.message((
              <div>
                <p> We couldn't create your booking with that timeslot because it's already taken. </p>
                <p> Please choose another timeslot and try again. </p>
              </div>
            ))
            // console.log("SUMMARY:\n timeslot was already taken, so we're wiping the current selection.");
            this.props.handleAppEvent(E.events.DATETIME_MOD_TIME, null);
            break;
          }
          default: {
            // Empty
          }
        }
      }

      this.props.handleAppPopup(newErrorPopup);
      this.setState({ submittingCreate: false });
    });
  }

  // Renamed method with swapped return values
  isPhoneValid() {
    const phoneField = document.querySelector('.invalid-field-phone');
    if (phoneField) {
      // console.log('document.querySelector: ', phoneField);
      // console.log('document.querySelector Style: ', phoneField.style.display);
      return phoneField.style.display !== 'block';
    }
    return true; // If the element doesn't exist, assume it's valid
  }

  // New method for email validation
  isEmailValid() {
    const emailField = document.querySelector('.invalid-field-email');
    if (emailField) {
      // console.log('document.querySelector: ', emailField);
      // console.log('document.querySelector Style: ', emailField.style.display);
      return emailField.style.display !== 'block';
    }
    return true; // If the element doesn't exist, assume it's valid
  }

  isFirstNameValid() {
    const firstNameField = document.querySelector('.input-first-name .invalid-field-text');
    if (firstNameField) {
      // console.log('First Name Field: ', firstNameField);
      // console.log('First Name Field Style: ', firstNameField.style.display);
      return firstNameField.style.display !== 'block';
    }
    return true; // If the element doesn't exist, assume it's valid
  }

  isLastNameValid() {
    const lastNameField = document.querySelector('.input-last-name .invalid-field-text');
    if (lastNameField) {
      // console.log('Last Name Field: ', lastNameField);
      // console.log('Last Name Field Style: ', lastNameField.style.display);
      return lastNameField.style.display !== 'block';
    }
    return true; // If the element doesn't exist, assume it's valid
  }

  // ===============================================================================================
  render() {
    let loginSectionTitle = {
      "hosted": "Big kid's (Birthday child's) details",
      "no-host": "Host's details",
    }

    if (this.props.eventType === 'no-host' && this.props.sSummary.first_name === '') {
      let starList = this.props.sIntro.stars;
      if (starList.length > 0) {
        this.props.sSummary.first_name = starList[0].name;
      }
    }
    let firstName = this.props.sSummary.first_name;

    let loginSection = (

      <div className="cont-group cont-group--signedin">

        <InputText
          type="text"
          className="input-first-name"
          placeholder="First Name"
          value={firstName}
          maxLength={40}
          handleChange={this.handleFirstNameChange}
        />
        <InputText
          type="text"
          className="input-last-name"
          placeholder="Last Name"
          value={this.props.sSummary.last_name}
          maxLength={40}
          handleChange={this.handleLastNameChange}
        />
        <InputText
          type="email"
          placeholder="Email"
          value={this.props.sSummary.email}
          maxLength={40}
          handleChange={this.handleEmailChange}
        />
        <InputText
          type="phone"
          placeholder="Phone Number"
          value={this.props.sSummary.phone}
          maxLength={15}
          handleChange={this.handlePhoneChange}
        />
      </div>
    )

    // ---------------------------------------------------------------------------------------------
    // Price display
    let iPrice = this.props.price;
    let sPrice = "" + iPrice;
    let priceOne = 0;
    let priceTwo = (iPrice < 10) ? "0" + sPrice : sPrice;

    if (iPrice > 99) {
      priceOne = sPrice.substring(0, sPrice.length-2)
      priceTwo = sPrice.substring(sPrice.length-2)
    }

    // ---------------------------------------------------------------------------------------------
    // Check if we can submit the form
    let foundErrors = false;
    if (!this.isFirstNameValid()) {
      foundErrors = true;
    }
    if (!this.isLastNameValid()) {
      foundErrors = true;
    }
    if (!this.isEmailValid()) {
      foundErrors = true;
    }
    if (!this.isPhoneValid()) {
      foundErrors = true;
    }

    if (this.props.sIntro.error || this.props.sPackage.error || this.props.sLocation.error || this.props.sDatetime.error || this.props.sCake.error) {
      foundErrors = true;
    }

    if (this.props.sSummary.first_name === "" || this.props.sSummary.last_name === "" || this.props.sSummary.email === "" || this.props.sSummary.phone === "" || this.props.sSummary.tAndC !== true || this.props.sSummary.privacy !== true ) {
      foundErrors = true;
    }

    this.canSubmit = (foundErrors === false) ? true : false;

    // ---------------------------------------------------------------------------------------------
    // Check which set of buttons to show
    let submitButtonContainer = (
      <div className="submit-btn-container">
        <BookingButton
          label="Enquire Now"
          className="create-booking-btn"
          canSubmit={this.canSubmit}
          inProgress={this.state.submittingCreate}
          disabled={!this.canSubmit              || this.state.submittingCreate ||
                     this.state.submittingUpdate || this.state.submittingCancel}
          handleClick={this.createBooking}
        />
      </div>
    )

    // ---------------------------------------------------------------------------------------------
    return (
      <div className="cont-section cont-section--offset-header cont-section--offset-sidebar cont-section--summary">
        <div className="cont-wrapper">
          <h1>
            {loginSectionTitle[this.props.eventType]}
          </h1>

          <form name="formName">
            {loginSection}

            <div className="cont-group cont-group--special">
              <h1>
                Special requirements
              </h1>
              <InputText
                type="summary"
                placeholder="e.g. accessibility considerations, food allergies, etc."
                value={this.props.sSummary.reqs}
                maxLength={80}
                handleChange={this.handleRequirementsChange}
              />
            </div>

            <div className="cont-group cont-group--summary">
              <SummarySection
                type={          "summary"                }
                items={         this.props.items         }
                activeSlide={   this.props.activeSlide   }
                visitedSlides={ this.props.visitedSlides }
                sIntro={        this.props.sIntro        }
                sPackage={      this.props.sPackage      }
                sLocation={     this.props.sLocation     }
                sDatetime={     this.props.sDatetime     }
                sCake={         this.props.sCake         }
                sSummary={      this.props.sSummary      }
                handleClick={   this.handleSummaryClick  }
              />
            </div>

            <div className="cont-group cont-group--total">
              <div className="total-text">Total (Incl. GST)</div>
              <div className="total-amount">
                <span className="total-sign">    $           </span>
                <span className="total-greater"> {priceOne}. </span>
                <span className="total-lesser">  {priceTwo}  </span>
                <span className="total-disc Mcd_BPB__disclaimer-text"> * </span>
              </div>
            </div>

            {/* <Divider type="dotted-white"/> */}

            <div className="cont-group cont-group--confirm">
              <div className="cont-group--confirm-top">
                <h1>
                  Confirm booking
                </h1>
                <p>
                  { this.props.eventType === 'hosted' && (
                    "McDonald's Birthday Parties are paid for on the day of your party. You can pick your invitations up from your chosen restaurant at your convenience. We hope everyone has a blast!" 
                  )}
                  { this.props.eventType === 'no-host' && (
                    "McDonald's Parties are paid for on the day of your party. You can pick your invitations up from your chosen restaurant at your convenience. We hope everyone has a blast!" 
                  )}
                </p>
              </div>
              
              {/* <InputCheckbox
                label="I've read and accept the terms and conditions."
                disabled={false}
                checked={this.state.checked}
                handleChange={this.handleCheckboxClick}
              /> */}
              <InputToggle
                label="I have read and accept the <a href='https://www.mcdonalds.com.au/parties-terms-and-conditions' target='_blank' rel='noopener noreferrer'>Terms & Conditions</a>"
                checked={this.props.sSummary.tAndC}
                class='row-reverse'
                handleChange={this.handleToggleClick}
              />
              <InputToggle
                label="I have read and accept the <a href='https://mcdonalds.com.au/mymaccas-privacy-collection' target='_blank' rel='noopener noreferrer'>Privacy Collection Statement</a>"
                checked={this.props.sSummary.privacy}
                class='row-reverse'
                handleChange={this.handleToggleClick2}
              />
              {submitButtonContainer}
            </div>
          </form>

        </div>
      </div>
    );
  }
}

export default SectionSummary